'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Convert raw javascript objects into google.maps.LatLng
 */
function composePosition(_ref) {
  var {
    position,
    google
  } = _ref;

  if (position instanceof google.maps.LatLng) {
    return position;
  }

  var {
    lat = null,
    lng = null
  } = position !== null && position !== void 0 ? position : {};
  return new google.maps.LatLng(lat, lng);
}

exports.composePosition = composePosition;
